/** The slice of `meta.permissions[gameId]` from `GET /games/:id` this rule reads. */
export interface PenaltyNotesPermissions {
  admin?: boolean
  score?: boolean
}

/** The slice of `game.user_active_game_roles` this rule reads. */
export interface PenaltyNotesRoles {
  is_game_official?: boolean
}

/**
 * Penalty notes are private to the people running the game: a game admin, a
 * scorekeeper (who writes them from the scoring app), or an assigned game
 * official. Players, team officials and the public never see them — and
 * neither does a bare game `update` permission.
 */
export const canViewPenaltyNotes = (
  permissions?: PenaltyNotesPermissions | null,
  roles?: PenaltyNotesRoles | null
): boolean =>
  Boolean(permissions?.admin || permissions?.score || roles?.is_game_official)
